import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';

/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

var finalSaleTag = 'final-sale',
    translations = window.translations,
    localeUrl = window.localeUrl,
    moneyFormatTranslation = window.localeUrl == '/fr' ? "{{amount_with_comma_separator}} $" : theme.moneyFormat;


export function lineItemCardHtml($itemData, $lineItemAddedQuantity = 0){
    // Populate line item into card
    var $lineItemCard = "";

    // Get item image
    var $lineItemImage = '';

    if (typeof $itemData.image != 'undefined' && $itemData.image != '') {
        $lineItemImage = $itemData.image;
    } else if($itemData.featured_image.url){
        $lineItemImage = itemData.featured_image.url;
    }

    // Get item url
    var $lineItemUrl = $itemData.url;
    // Get item title
    var $lineItemTitle = $itemData.product_title;

    // Get item prices
    var $lineItemPrice       = formatMoney($itemData.price, moneyFormatTranslation), // Current Price
    $lineItemOriginalPrice   = formatMoney($itemData.original_price, moneyFormatTranslation), // Original Price
    $lineItemComparePrice    = '',
    $lineItemComparePriceRaw = null;
    // Get variant title
    if ( $itemData.variant_title != null ) {
        var $lineItemVariantTitle = $itemData.variant_title.replace(' / ', ', ');
    }

    // Get product handle
    var $productHandle = $itemData.handle;
    // Final Sale Product - Check if the product is final sale or not based on tags
    var $isFinalSale = false;
    $.ajax({
        url: localeUrl+'/products/'+ $productHandle +'.js',
        dataType: 'json',
        async: false,
        success: function(product) {

            // get product compare at price max
            $.each(product.variants, function(index, value){

                if( $itemData.id == value.id){
                    $lineItemComparePrice    = formatMoney(value.compare_at_price, moneyFormatTranslation);
                    $lineItemComparePriceRaw = value.compare_at_price;
                }
            })

            // Get product tags
            $.each( product.tags, function(index, value){
                if( value == finalSaleTag){
                    $isFinalSale = true;
                    return false;
                }
            } )
        }
    });

    $lineItemCard += '<article class="card card--default card--line-item card--line-item--placeholder">';

        // Image with link
        $lineItemCard += '<a tabindex="-1" href='+ $lineItemUrl +'>';
        if ( $lineItemImage !== null && $lineItemImage != '') {
            $lineItemCard += '<img alt="'+ $lineItemTitle +'" class="line-item__image" src="'+ $lineItemImage +'"/>';
        }
        $lineItemCard += '</a>';
        $lineItemCard += '<div class="">';
        // Title
        if ( $lineItemTitle.length ) {
            $lineItemCard += '<h3 class="card__title">'+ $lineItemTitle +'</h3>';
        }

        // Meta
        $lineItemCard += '<div class="card__metadata">';
            // Variant Title
            if ( typeof $lineItemVariantTitle != 'undefined' ) {
                $lineItemCard += '<p class="line-item__variant-title">'+ $lineItemVariantTitle +'</p>';
            }

            // Quantity
            if ( $lineItemAddedQuantity > 0 ) {
                var $lineItemQuantity = $lineItemAddedQuantity;
            }else{
                var $lineItemQuantity = $itemData.quantity;
            }
            $lineItemCard += '<p class="line-item__added-quantity">'+ translations.shortQuantity +': '+ $lineItemQuantity +'</p>';

            // Prices
            $lineItemCard += '<div data-price-wrapper="" class="card__price">';
                if ( $lineItemOriginalPrice != $lineItemPrice) {
                    $lineItemCard += '<span class="visually-hidden" data-original-price-text="">Original Price</span>';
                    $lineItemCard += '<s data-original-price="">'+ $lineItemOriginalPrice +'</s>';
                }
                $lineItemCard += '<span data-product-price="" class="card__price--original">'+ $lineItemPrice +'</span>';
            $lineItemCard += '</div>';

            // Final Sale
            if ( $isFinalSale == true ) {
                $lineItemCard += '<div class="line-item__final-sale">';
                    $lineItemCard += '<span>'+ translations.finalSaleLabel +'</span>';
                    $lineItemCard += '<div class="tooltip tooltip--default">';
                        // Tooltip Icon - Final Sale svg - should include via css?
                        $lineItemCard += '<span class="tooltip__icon tooltip__icon--final-sale"><svg class="icon icon__tooltip"><use xlink:href="#icon-tooltip"></use></svg></span>';
                        // Tooltip Description - Final Sale
                        $lineItemCard += '<div class="tooltip__content">'+ translations.finalSaleMessage +'</div>';
                    $lineItemCard += '</div>';
                $lineItemCard += '</div>';
            }

        $lineItemCard += '</div></div>';

    $lineItemCard += '</article>';

    return $lineItemCard;
}

// Get current cart information and output as html
export function cartSubtotalUpdate(cartData){

    var _config = {
        cartCountSelector: '.cart__item-count',
    };

    // Get number of items in cart
    var $cartItemsNum = parseInt(cartData.item_count);
    if( $cartItemsNum > 1 ){
        var $cartItemsNumLabel = translations.itemCountOther;
    }else{
        var $cartItemsNumLabel = translations.itemCountOne;
    }

    var $subTotalLabel = translations.subTotalLabel;

    // Get items subtotal price
    var $cartSubtotal = formatMoney(cartData.items_subtotal_price, moneyFormatTranslation);

    if( $('.cart-subtotal__container').length ){

        $.each($('.cart-subtotal__container'), function(){
            $(this).find('.cart-info__item-count').text($subTotalLabel + ' ('+ $cartItemsNum +' '+ $cartItemsNumLabel +')');
            $(this).find('.cart-info__subtotal').text($cartSubtotal);
        });
    }

    // Update cart count
    const cartCountElements = document.querySelectorAll(_config.cartCountSelector);
    if (cartCountElements.length) {
        cartCountElements.forEach(element => {
            element.textContent = cartData.item_count;
        });
    }
}


document.addEventListener('DOMContentLoaded', function(){

    Shopify.AjaxifyCart = (function() {

        // Some configuration options.
        // I have separated what you will never need to change from what
        // you might change.

        const _config = {

            // What you might want to change
            addToCartBtnLabel             : translations.addToCart,
            addedToCartBtnLabel           : translations.addedToCart,
            addingToCartBtnLabel          : translations.addingToCart,
            soldOutBtnLabel               : translations.soldOut,
            howLongTillBtnReturnsToNormal : 800, // in milliseconds.
            cartCountSelector             : '.cart__item-count',
            cartTotalSelector             : '#cart-price',

            // What you will never need to change
            addToCartBtnSelector          : '.btn--add-to-cart--quick',
            addToCartFormSelector         : 'form[action="'+localeUrl+'/cart/add"]',
            shopifyAjaxAddURL             : localeUrl+'/cart/add.js',
            shopifyAjaxCartURL            : localeUrl+'/cart.js',
            productPriceWrapper           : '[data-price-wrapper]',
            productComparePrice           : '[data-compare-price]',
            productQuantityInput          : 'input[name="quantity"]',

            // Cart Confirmation Modal configs
            cartModal                     : '.modal--cart-confirmation',
            cartModalMessage              : '.cart-confirmation__message',
            cartModalItem                 : '.cart-confirmation__item',
            cartModalCartInfo             : '.cart-subtotal__container',
        };

        // We need some feedback when adding an item to the cart.
        // Here it is.
        var _showFeedback = function($itemData) {

            $(_config.cartModalMessage).html(translations.modalSuccessMessage);

            // Get product quantity added to cart
            var $lineItemAddedQuantity = $(_config.addToCartFormSelector).find(_config.productQuantityInput).val();

            // Get Added Item info and append to the modal
            var $lineItemCardHtml = lineItemCardHtml($itemData, $lineItemAddedQuantity);
            $(_config.cartModalItem).html($lineItemCardHtml);

            // Open the modal after the item is added
            var $modal = $(_config.cartModal);
            $modal.addClass('modal--open');
            $('body').addClass('noscroll');

            $modal.find('[tabindex="-1"]').each(function(){
                $(this).attr('tabindex', 0);
            });

            // Broadcast a notification that a modal opened
            $(window).trigger('open.modal', $modal);

            // ---------------------------------------------
            // Trap Focus inside the Cart Confirmation Modal
            // ---------------------------------------------

            // add all the elements inside modal which you want to make focusable
            const focusableElements    = 'button, [tabindex]:not([tabindex="-1"]), [href]';
            const modal                 = document.querySelector('#modal_cart_confirmation'); // select the modal by it's id
            const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
            const focusableContent      = modal.querySelectorAll(focusableElements);
            const lastFocusableElement  = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

            // Move focus from the Add to Cart Button to the modal close button
            firstFocusableElement.focus();

            document.addEventListener('keydown', function(e) {
                let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed) {
                    return;
                }

                if (e.shiftKey) { // if shift key pressed for shift + tab combination
                    if (document.activeElement === firstFocusableElement) {

                        e.preventDefault();
                        lastFocusableElement.focus(); // add focus for the last focusable element
                    }
                } else { // if tab key is pressed

                    if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab

                        e.preventDefault();
                        firstFocusableElement.focus(); // add focus for the first focusable element
                    }
                }
            });
        };

        const _setText = function(button, label) {
            if (button && button.children.length) {
                Array.from(button.children).forEach(function(child) {
                    if (child.textContent.trim() !== '') {
                        child.textContent = label;
                    }
                });
            } else if (button) {
                button.textContent = label;
            }
        };

        const _init = function() {
            // Empty the cart if there are only free sample products in cart
            fetch(_config.shopifyAjaxCartURL, {
                method: 'GET',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(cart => {
                const cart_items_subtotal_price = cart.items_subtotal_price;
                const cart_item_count = cart.item_count;
                if (cart_items_subtotal_price == 0 && cart_item_count > 0) {
                    fetch(localeUrl+'/cart/clear.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({})
                    })
                    .then(() => {
                        location.reload(true);
                    })
                    .catch(error => {
                        console.error(error);
                    });
                }
            })
            .catch(error => {
                console.error(error);
            });

            // Loop through all ATC forms, in case quick ATC is present in product cards.
            const addToCartForms = document.querySelectorAll(_config.addToCartFormSelector);

            addToCartForms.forEach((addToCartForm) => {

                if ( addToCartForm.dataset.isAjax == 'true' ) {

                    addToCartForm.addEventListener('submit', function(e){
                        e.preventDefault();

                        // Remove error message
                        addToCartForm.querySelector('.cart__message--error').textContent = '';

                        const addToCartBtn      = addToCartForm.querySelector(_config.addToCartBtnSelector),
                            addToCartText     = addToCartForm.querySelector('[data-add-to-cart-text]'),
                            addToCartBtnCard  = addToCartForm.querySelector('.quick-cart-add__loader'),
                            addToCartType     = addToCartForm.dataset.addCartType;

                        //Get current label to reapply after cart submitted
                        _config.addToCartBtnLabel = addToCartText.textContent;

                        if(document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                        }else if(addToCartForm.dataset.addCartType == 'modal'){ // Cart Modal case
                            // Change Button Text to indicate that product is adding to cart
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                            addToCartBtn.classList.add('disabled');
                            addToCartBtn.disabled = true;
                            addToCartBtn.classList.add('button--active');
                        }else{
                            _setText(addToCartBtnCard, _config.addingToCartBtnLabel);
                        }

                        // Add to cart.
                        const formData = new FormData(addToCartForm);

                        fetch(_config.shopifyAjaxAddURL, {
                            method: 'POST',
                            body: formData
                        })
                        .then((response) => {
                            if(response.status !== 200) {
                                throw response;
                            } else {
                                return response.json();
                            }
                        })
                        .then((itemData) => {
                            console.log(itemData);
                            // Re-enable add to cart button.
                            if(addToCartBtnCard) addToCartBtnCard.classList.add('button--active');

                            if(addToCartForm.dataset.addCartType == 'modal'){
                                // Update mini cart
                                Shopify.miniCart.init();

                                // Update free shipping progress
                                Shopify.freeShippingProgress.init();
                            }

                            if(document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                _setText(addToCartText, _config.addedToCartBtnLabel);
                                addToCartBtn.classList.add('disabled');
                                addToCartBtn.disabled = true;
                                addToCartBtn.classList.add('button--active');
                            }else {
                                _setText(addToCartBtnCard, _config.addedToCartBtnLabel);
                            }

                            window.setTimeout(function(){
                                if(addToCartBtnCard) addToCartBtnCard.classList.remove('button--active');
                                addToCartBtn.classList.remove('button--active');
                                addToCartBtn.classList.remove('disabled');
                                addToCartBtn.disabled = false;

                                if(document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                    _setText(addToCartText, _config.addToCartBtnLabel);
                                }else if(addToCartForm.dataset.addCartType == 'modal'){ // Cart Modal case
                                    _setText(addToCartText, _config.addToCartBtnLabel);
                                    _showFeedback(itemData);
                                }else if(addToCartForm.dataset.addCartType == 'upsell-modal'){
                                    _setText(addToCartText, _config.addToCartBtnLabel);
                                }
                            }, _config.howLongTillBtnReturnsToNormal);

                            // Update cart count
                            fetch(_config.shopifyAjaxCartURL, {
                                cache: 'no-cache',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })
                            .then((response) => response.json())
                            .then((cart) => {
                                const cartCountElements = document.querySelectorAll(_config.cartCountSelector);
                                if (cartCountElements && cartCountElements.length > 0) {
                                    cartCountElements.forEach((element) => {
                                        element.textContent = cart.item_count;
                                    });
                                }
                            });
                        })
                        .catch(async (error) => {
                            try {
                                const errorObject = await error.json();
                                if (errorObject?.description) {
                                    const response = errorObject.description;
                                    console.log(response);
                                    const errorElement = addToCartForm.querySelector('.cart__message--error');
                                    if(errorElement) errorElement.textContent = response;

                                    if (response.slice(0,4) === 'All ') {
                                        _setText(addToCartText, _config.soldOutBtnLabel);
                                        addToCartBtn.disabled = true;
                                    } else {
                                        addToCartBtn.disabled = false;
                                        addToCartBtn.classList.remove('disabled');
                                        _setText(addToCartText, _config.addToCartBtnLabel);
                                    }
                                }
                            } catch {
                                console.error('Error parsing response:', error);
                            }
                        });

                        return false;

                    });
                }
            });
        };
        return {
            init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                Object.assign(_config, params);
                // Action
                _init();
            },
            getConfig: function() {
                return _config;
            }
        };
    });
    Shopify.AjaxifyCart().init();
});
